// extracted by mini-css-extract-plugin
export default {"wrapAddress":"AddressField_wrapAddress__R+kw-","address":"AddressField_address__tq4hO","txtInfo":"AddressField_txtInfo__un+fk","accentTxt":"AddressField_accentTxt__K5i1g"};